import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import ImageDesktopWebp from './images/neighbors-having-coffee-desktop.webp';

export default () => {
  return (
    <InformationalModule
      sectionId='financial-information-financial-planning-1'
      moduleName='financial-planning-module'
      moduleVariation='A'
      themeType='lightTheme'
      // content
      headingText={<>Trust starts with <WidowBlock>financial strength</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography
            component='h3'
            nextElement='typography'>
            We&#39;re among <WidowBlock>the strongest.</WidowBlock>
          </Typography>
          <Typography nextElement='button'>
            More people are putting their trust in Northwestern Mutual&#8212;which is the ultimate measure of
            success. Exceptional financial strength means you can count on us to be here when you need us.
            In 2024, the company thrived despite the year&#39;s continuing uncertainty and challenges,
            producing record revenue and surplus, declaring the company&#39;s largest&#45;ever dividend payout,
            and maintaining the highest available financial strength ratings awarded to any U.S. life
            insurer by all of the four major rating agencies.
          </Typography>
          <Link
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            id='financial-information-financial-planning-section-annual-report-cta'
            linkUrl='/2024-annual-report/'>
            See our 2024 Annual Report
          </Link>
        </>
      )}
      // image props
      imageAltText='Three neighbors having coffee together outside'
      imageSrcDefault={ImageDesktopWebp.toString()}
    />
  );
};
